import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postScheduleList: (params: ProjectListReqDto): Promise<ScheduleListResDto> =>
    request({
      url: endpoints.schedule.list,
      method: 'post',
      data: paramsToFormData(params),
    }),              
};
